import queryString from 'query-string';
import { useIntl } from 'react-intl';
import { useSearch } from 'wouter';

import Metadata from './Metadata';

function SearchMetadata() {
    const intl = useIntl();
    const search = useSearch();
    const { q = null } = queryString.parse(search);

    return (
        <Metadata
            title={intl.formatMessage({
                defaultMessage: 'Recherche',
                description: 'Page title',
            })}
            noIndex={q !== null}
            pageType="search"
        />
    );
}

export default SearchMetadata;
